import { Home, LocalGasStation, Assessment, AccountCircle , EmojiTransportation} from '@mui/icons-material'
import IntlMessages from '../util/IntlMessages'
import * as router from './router'

export const menuList = [
    { router: router.HOME, label: <IntlMessages id="home" />, icon: <Home /> },
    { router: router.SALES, label: <IntlMessages id="sales" />, icon: <LocalGasStation /> },
    { router: router.REFUEL_TANKER, label: <IntlMessages id="refuelTanker" />, icon: <EmojiTransportation /> },
    { router: router.FINANCIAL, label: <IntlMessages id="financial" />, icon: <Assessment /> },
    { router: router.PROFILE, label: <IntlMessages id="profile" />, icon: <AccountCircle /> },
]
